/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Additional_Instructions_LabelInputs */

const en_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional context and instructions for the LLM`)
};

const fr_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations complémentaires et instructions pour le LLM`)
};

const de_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusätzlicher Kontext und Anweisungen für den LLM`)
};

const it_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contesto e istruzioni aggiuntive per il Master in Giurisprudenza (LLM)`)
};

const ru_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительная информация и инструкции для программы магистра права (LLM).`)
};

const es_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto e instrucciones adicionales para el LLM`)
};

const zh_cn2_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于法学硕士（LLM）的更多背景信息和说明`)
};

const ja_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLMに関する追加情報と指示`)
};

const hi_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एलएलएम के लिए अतिरिक्त संदर्भ और निर्देश`)
};

const pt_pt2_additional_instructions_label = /** @type {(inputs: Additional_Instructions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto e instruções adicionais para o LLM`)
};

/**
* | output |
* | --- |
* | "Additional context and instructions for the LLM" |
*
* @param {Additional_Instructions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const additional_instructions_label = /** @type {((inputs?: Additional_Instructions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Additional_Instructions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_additional_instructions_label(inputs)
	if (locale === "de") return de_additional_instructions_label(inputs)
	if (locale === "it") return it_additional_instructions_label(inputs)
	if (locale === "ru") return ru_additional_instructions_label(inputs)
	if (locale === "es") return es_additional_instructions_label(inputs)
	if (locale === "zh-CN") return zh_cn2_additional_instructions_label(inputs)
	if (locale === "ja") return ja_additional_instructions_label(inputs)
	if (locale === "hi") return hi_additional_instructions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_additional_instructions_label(inputs)
	return en_additional_instructions_label(inputs)
});